import { render } from "./ComparativeTVPHighVariance.vue?vue&type=template&id=71c4d1c0"
import script from "./ComparativeTVPHighVariance.vue?vue&type=script&lang=js"
export * from "./ComparativeTVPHighVariance.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__